import React from 'react';
import { BB, GRAY20, GRAY30, GRAY70 } from 'global-styles';
import styled, { css } from 'styled-components';
import { useBlogContext } from 'context/BlogContext';
import { PostCategory } from 'react-query/blogApi';

interface CategoryTabItem {
  label: string;
  value: 'all' | PostCategory;
}

const tabs: CategoryTabItem[] = [
  { label: 'All', value: 'all' },
  { label: 'Technology', value: 'technology' },
  { label: 'Media Trend', value: 'media trend' },
  { label: 'News', value: 'news' },
];

const CategoryTab = () => {
  const {
    state: { category },
    dispatch,
  } = useBlogContext();
  const handleChangeCategory = (category: CategoryTabItem['value']) =>
    dispatch({ type: 'change', newState: { category, currPageNum: 1 } });

  return (
    <CategoryTabContainer>
      {tabs.map(tab => (
        <TabItem key={tab.value} isSelected={tab.value === category}>
          <button onClick={() => handleChangeCategory(tab.value)}>
            {tab.label}
          </button>
        </TabItem>
      ))}
    </CategoryTabContainer>
  );
};

export default CategoryTab;

export const CategoryTabContainer = styled.ul`
  padding: 8px 0;
  display: flex;
  justify-content: center;
  @media screen and (max-width: 768px) {
    justify-content: flex-start;
    overflow-x: auto;
  }
`;

interface TabItem {
  isSelected: boolean;
}

export const TabItem = styled.li<TabItem>`
  flex-shrink: 0;
  width: 120px;
  height: 40px;
  & > button {
    border: 1px solid ${GRAY70};
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 14px;
    line-height: 21px;
    width: 100%;
    height: 100%;
    color: ${GRAY30};
    transition: 0.2s all;
    overflow: hidden;
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      & > button {
        background: ${BB};
        border: 1px solid ${BB};
        color: #fff;
      }
    `};

  & + & {
    margin-left: 12px;
  }
  &:hover > button {
    border: 1px solid ${GRAY20};
  }
`;
